export default {
  app: {
    golf: {
      title: '球场信息',
      hasEVChargingPoint: '电动车充电点',
      hasCaddieService: '球童服务',
      hasTrolley: '手推车',
      hasBuggy: '球车',
      hasClubRental: '球杆租赁',
      hasAcademy: '学院',
      hasMarshal: '球场管理员',
      hasPGACertification: 'PGA认证',
      hasTrainingArea: '训练区',
      hasRestaurant: '餐厅',
      hasHotel: '酒店',
      hasDogsOnCourse: '球场允许携带狗',
      numberOfHoles: '球洞数量',
    },
  },
};
